import { store } from 'redux/store/configureStore';
import * as NotificationActions from 'redux/actions/notification';

export const markReadAllNotifications = () => {
    store.dispatch(NotificationActions.markReadAll());
};
